__turbopack_context__.v({
  "avatar": "xH4xyW_avatar",
  "worker-blink": "xH4xyW_worker-blink",
  "worker-breathe": "xH4xyW_worker-breathe",
  "worker-sleep": "xH4xyW_worker-sleep",
});
